import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = {
  class: "tab-content",
  id: "nav-tabContent"
}
const _hoisted_4 = {
  class: "tab-pane p-3 fade show active",
  id: "nav-dados",
  role: "tabpanel",
  "aria-labelledby": "nav-home-tab",
  tabindex: "0"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "row mb-2" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = { class: "row mb-2" }
const _hoisted_10 = { class: "col-md-9" }
const _hoisted_11 = { class: "row mb-2" }
const _hoisted_12 = { class: "col-md-9" }
const _hoisted_13 = { class: "row mb-2" }
const _hoisted_14 = { class: "col-md-9" }
const _hoisted_15 = { class: "row mb-2" }
const _hoisted_16 = { class: "col-md-9" }
const _hoisted_17 = { class: "row mb-2" }
const _hoisted_18 = { class: "col-md-9" }
const _hoisted_19 = { class: "row mb-2" }
const _hoisted_20 = { class: "col-md-9" }
const _hoisted_21 = { class: "row mb-2" }
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "row mb-2" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "row mb-2" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "row mb-2" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "row mb-2" }
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "input-group" }
const _hoisted_36 = ["value"]
const _hoisted_37 = { class: "row mb-2" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "row mb-2" }
const _hoisted_40 = { class: "col-md-6" }
const _hoisted_41 = { class: "row mb-2" }
const _hoisted_42 = { class: "col-md-4" }
const _hoisted_43 = ["value"]
const _hoisted_44 = {
  class: "tab-pane p-3 fade",
  id: "nav-composicao",
  role: "tabpanel",
  "aria-labelledby": "nav-composicao-tab",
  tabindex: "0"
}
const _hoisted_45 = {
  key: 0,
  class: "row mb-2"
}
const _hoisted_46 = { class: "row mb-2" }
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = { class: "col-md-2" }
const _hoisted_49 = { class: "row mb-2" }
const _hoisted_50 = { class: "col-md-12" }
const _hoisted_51 = { class: "table table-sm table-striped table-bordered table-hover" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "row mb-2" }
const _hoisted_55 = { class: "col-md-12" }
const _hoisted_56 = { class: "" }
const _hoisted_57 = { class: "text-center" }
const _hoisted_58 = { class: "" }
const _hoisted_59 = { class: "text-danger fw-bold" }
const _hoisted_60 = {
  class: "tab-pane p-3 fade",
  id: "nav-contrato",
  role: "tabpanel",
  "aria-labelledby": "nav-profile-tab",
  tabindex: "0"
}
const _hoisted_61 = { class: "row mb-2" }
const _hoisted_62 = { class: "col-md-12" }
const _hoisted_63 = { class: "card-footer" }
const _hoisted_64 = { class: "row" }
const _hoisted_65 = { class: "col-md-2" }
const _hoisted_66 = { class: "col-md-4" }
const _hoisted_67 = {
  key: 0,
  class: "fw-bold"
}
const _hoisted_68 = {
  key: 1,
  class: "fw-bold text-danger"
}
const _hoisted_69 = { class: "col-md-2" }

import {  onMounted, reactive } from "vue";
import { useRoute } from 'vue-router';

//servicos
import config from "@/app.config.json";
import * as service from "@/services/clientesContratosService";
import * as composicoesService from "@/services/contratosComposicoesService";

//componentes
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TextBox from "@/components/TextBox/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import Notificacao from "@/components/Notificacao/Index.vue";

import DropdownPlanos from "@/components/Dropdowns/DropdownPlanos.vue";
import DropdownUsuarios from "@/components/Dropdowns/DropdownUsuarios.vue";
import DropdownEmpresas from "@/components/Dropdowns/DropdownEmpresas.vue";
import DropdownClientes from "@/components/Dropdowns/DropdownClientes.vue";
import DropdownSimNao from "@/components/Dropdowns/DropdownSimNao.vue";
import Editor from '@tinymce/tinymce-vue'

import { fdataHora, fdataUS, fdataUSS, setaFocus } from "@/utils/funcoes";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Cadastro',
  setup(__props) {


//vue
const route = useRoute();

  var controle = reactive({

    model: {
      
    } as service.Contrato,
    tipos: ['Familiar', 'Empresarial'] ,
    simNao: [
      { texto: 'SIM', valor: true }, 
      { texto: 'NÃO', valor: false }] as { texto: string; valor: boolean }[],
    status2: [
      { texto: 'Pendente', valor: 1 },
      { texto: 'Ativo', valor: 2 }] as { texto: string; valor: number }[],
      erro: "",
      status: "",

      composicoes: [] as composicoesService.ContratoComposicao[],
      novaComposicaoClienteId: null as number | null,
      erroComposicao: "",
      statusComposicao: "",
  })

  onMounted(() => {

    console.log("buscar")
    if (route.params.id) {
      // Se houver um ID na rota, buscar os detalhes do usuário
      service.obterPorId(Number(route.params.id))
        .then(r => {
          controle.model = r;
          buscarComposicoes();
        })
        .catch(error => {
          controle.erro = `Erro ao carregar: ${error}`;
        });
    }

    setaFocus("inputFocus");

  });

  function buscarComposicoes() {
    if (!controle.model.contratoId) return;

    composicoesService.obter({ contratoId: controle.model.contratoId } as composicoesService.Filtros)
      .then((r) => {
        controle.composicoes = r;
      })
      .catch((error) => {
        controle.erroComposicao = `Erro ao buscar composição: ${error}`;
      });
  }

  function adicionarComposicao() {
    if (!controle.novaComposicaoClienteId) {
      controle.erroComposicao = "Selecione um cliente!";
      return;
    }

    controle.statusComposicao = "Adicionando...";
    controle.erroComposicao = "";

    composicoesService.adicionar({
      contratoId: controle.model.contratoId,
      clienteId: controle.novaComposicaoClienteId,
      planoId: controle.model.planoId,
    } as composicoesService.ContratoComposicao)
      .then(() => {
        controle.statusComposicao = "";
        controle.novaComposicaoClienteId = null;
        buscarComposicoes();
      })
      .catch((error) => {
        controle.erroComposicao = `Erro ao adicionar: ${error}`;
        controle.statusComposicao = "";
      });
  }

  function excluirComposicao(item: composicoesService.ContratoComposicao) {
    composicoesService.excluir(item.id)
      .then(() => {
        buscarComposicoes();
      })
      .catch((error) => {
        controle.erroComposicao = `Erro ao excluir: ${error}`;
      });
  }

  async function salvar() {
    try {
      // 1. Salvar o registro primeiro
      console.log("salvar", controle.model);

      if (controle.model.dataPriParcela != null)
        controle.model.dataPriParcela = fdataUSS(controle.model.dataPriParcela);

      if (controle.model.dataInicio != null)
        controle.model.dataInicio = fdataUSS(controle.model.dataInicio);
    
      if (controle.model.dataFim != null)
        controle.model.dataFim = fdataUSS(controle.model.dataFim);

      controle.status = "Gravando...";
      controle.erro = "";
      const resultado = await service.salvar(controle.model)
       controle.model.contratoId = resultado.contratoId;
       buscarComposicoes();
       controle.status = "Gravado com sucesso!";
       setTimeout(() => {
         controle.status = "";
       }, 3000);
    } catch (error) {
      controle.erro = `Erro ao salvar: ${error}...`;
      return;
    }
  }

 

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, {
      PageTitle: "Cadastro de Contratos",
      items: [ 
      { label: 'Contratos', to: '/contratos' }, 
      { label: 'Cadastro', to: '/contratos/cadastro' } ]
    }),
    _createVNode(Notificacao, {
      erro: _unref(controle).erro,
      onLimparErro: _cache[0] || (_cache[0] = ($event: any) => (_unref(controle).erro='')),
      progresso: _unref(controle).status,
      onLimparProgresso: _cache[1] || (_cache[1] = ($event: any) => (_unref(controle).status = ''))
    }, null, 8, ["erro", "progresso"]),
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[45] || (_cache[45] = _createElementVNode("nav", null, [
              _createElementVNode("div", {
                class: "nav nav-tabs",
                id: "nav-tab",
                role: "tablist"
              }, [
                _createElementVNode("button", {
                  class: "nav-link active",
                  id: "nav-home-tab",
                  "data-bs-toggle": "tab",
                  "data-bs-target": "#nav-dados",
                  type: "button",
                  role: "tab",
                  "aria-controls": "nav-home",
                  "aria-selected": "true"
                }, "Básico"),
                _createElementVNode("button", {
                  class: "nav-link",
                  id: "nav-composicao-tab",
                  "data-bs-toggle": "tab",
                  "data-bs-target": "#nav-composicao",
                  type: "button",
                  role: "tab",
                  "aria-controls": "nav-composicao",
                  "aria-selected": "false"
                }, "Composição"),
                _createElementVNode("button", {
                  class: "nav-link",
                  id: "nav-profile-tab",
                  "data-bs-toggle": "tab",
                  "data-bs-target": "#nav-contrato",
                  type: "button",
                  role: "tab",
                  "aria-controls": "nav-profile",
                  "aria-selected": "false"
                }, "Contrato")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "clienteId",
                          class: "form-label"
                        }, "ID")
                      ], -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(TextBox, {
                          modelValue: _unref(controle).model.contratoId,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).model.contratoId) = $event)),
                          id: "contratoId",
                          formato: 'Numero',
                          readonly: "",
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "ativo",
                          class: "form-label"
                        }, "Plano")
                      ], -1)),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(DropdownPlanos, {
                          modelValue: _unref(controle).model.planoId,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(controle).model.planoId) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "ativo",
                          class: "form-label"
                        }, "Vendedor")
                      ], -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(DropdownUsuarios, {
                          modelValue: _unref(controle).model.vendedorId,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(controle).model.vendedorId) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "ativo",
                          class: "form-label"
                        }, "Cliente")
                      ], -1)),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(DropdownClientes, {
                          modelValue: _unref(controle).model.clienteId,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(controle).model.clienteId) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "ativo",
                          class: "form-label"
                        }, "Investidor")
                      ], -1)),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(DropdownUsuarios, {
                          modelValue: _unref(controle).model.investidorId,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(controle).model.investidorId) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "ativo",
                          class: "form-label"
                        }, "Supervisor")
                      ], -1)),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(DropdownUsuarios, {
                          modelValue: _unref(controle).model.supervisorId,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(controle).model.supervisorId) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _cache[28] || (_cache[28] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "ativo",
                          class: "form-label"
                        }, "Empresa")
                      ], -1)),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(DropdownEmpresas, {
                          modelValue: _unref(controle).model.empresaId,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(controle).model.empresaId) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _cache[29] || (_cache[29] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "ativo",
                          class: "form-label"
                        }, "Pré Contrato")
                      ], -1)),
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(DropdownSimNao, {
                          modelValue: _unref(controle).model.preContrato,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(controle).model.preContrato) = $event)),
                          id: "preContrato",
                          class: "form-select form-select-sm"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _cache[30] || (_cache[30] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "dt1Parcela",
                          class: "form-label"
                        }, "Dt 1º Parcela")
                      ], -1)),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("input", {
                          value: _unref(fdataUS)(_unref(controle).model.dataPriParcela),
                          onInput: _cache[10] || (_cache[10] = (ev)=> _unref(controle).model.dataPriParcela = (ev.target as HTMLInputElement).value ),
                          id: "dt1Parcela",
                          type: "date",
                          class: "form-control form-control-sm"
                        }, null, 40, _hoisted_26)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _cache[31] || (_cache[31] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "dtInicio",
                          class: "form-label"
                        }, "Dt Inicio")
                      ], -1)),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("input", {
                          value: _unref(fdataUS)(_unref(controle).model.dataInicio),
                          onInput: _cache[11] || (_cache[11] = (ev)=> _unref(controle).model.dataInicio = (ev.target as HTMLInputElement).value ),
                          id: "dtInicio",
                          type: "date",
                          class: "form-control form-control-sm"
                        }, null, 40, _hoisted_29)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _cache[32] || (_cache[32] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "dtFim",
                          class: "form-label"
                        }, "Dt Fim")
                      ], -1)),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("input", {
                          value: _unref(fdataUS)(_unref(controle).model.dataFim),
                          onInput: _cache[12] || (_cache[12] = (ev)=> _unref(controle).model.dataFim = (ev.target as HTMLInputElement).value ),
                          id: "dtFim",
                          type: "date",
                          class: "form-control form-control-sm"
                        }, null, 40, _hoisted_32)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _cache[33] || (_cache[33] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "dtAssinatura",
                          class: "form-label"
                        }, "Dt Assinatura")
                      ], -1)),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            placeholder: "Sem assinar",
                            value: _unref(fdataHora)(_unref(controle).model.dataAssinatura)
                          }, null, 8, _hoisted_36),
                          _createElementVNode("a", {
                            class: "btn btn-sm btn-secondary",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(controle).model.dataAssinatura = null)),
                            title: "Limpar para assinar novamente"
                          }, " Limpar ")
                        ])
                      ]),
                      _cache[34] || (_cache[34] = _createElementVNode("div", { class: "col-md-2" }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _cache[35] || (_cache[35] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "dtFim",
                          class: "form-label"
                        }, "Assinatura")
                      ], -1)),
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(TextBox, {
                          modelValue: _unref(controle).model.assinatura,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(controle).model.assinatura) = $event)),
                          id: "assinatura",
                          formato: 'Texto',
                          class: ""
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _cache[36] || (_cache[36] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "observacoes",
                          class: "form-label"
                        }, "Observações")
                      ], -1)),
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(TextBox, {
                          modelValue: _unref(controle).model.observacoes,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(controle).model.observacoes) = $event)),
                          id: "observacoes",
                          formato: 'Texto',
                          class: ""
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _cache[37] || (_cache[37] = _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", {
                          for: "ativo",
                          class: "form-label"
                        }, "Status")
                      ], -1)),
                      _createElementVNode("div", _hoisted_42, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(controle).model.statusId) = $event)),
                          id: "statusId",
                          class: "form-select form-select-sm"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).status2, (tipo) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: String(tipo.valor),
                              value: tipo.valor
                            }, _toDisplayString(tipo.texto), 9, _hoisted_43))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _unref(controle).model.statusId]
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                (!_unref(controle).model.contratoId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [...(_cache[38] || (_cache[38] = [
                      _createElementVNode("div", { class: "col-md-12" }, [
                        _createElementVNode("p", null, "Necessário gravar o contrato antes de gerenciar a composição.")
                      ], -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _cache[39] || (_cache[39] = _createElementVNode("label", { class: "form-label" }, "Cliente", -1)),
                          _createVNode(DropdownClientes, {
                            modelValue: _unref(controle).novaComposicaoClienteId,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(controle).novaComposicaoClienteId) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("a", {
                            class: "btn btn-sm btn-primary mt-4",
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (adicionarComposicao()))
                          }, "Adicionar")
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("table", _hoisted_51, [
                            _cache[42] || (_cache[42] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "Cliente"),
                                _createElementVNode("th", null, "Plano"),
                                _createElementVNode("th", null, "Ações")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_unref(controle).composicoes.length == 0)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_52, [...(_cache[40] || (_cache[40] = [
                                    _createElementVNode("td", {
                                      colspan: "3",
                                      class: "text-center"
                                    }, "Nenhum registro", -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).composicoes, (item, index) => {
                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                  _createElementVNode("td", null, _toDisplayString(item.cliente?.nome), 1),
                                  _createElementVNode("td", null, _toDisplayString(item.plano?.nome), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("a", {
                                      class: "",
                                      title: "Excluir",
                                      href: "#",
                                      onClick: ($event: any) => (excluirComposicao(item))
                                    }, [...(_cache[41] || (_cache[41] = [
                                      _createElementVNode("i", { class: "flaticon-delete text-danger fs-5" }, null, -1)
                                    ]))], 8, _hoisted_53)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("p", _hoisted_56, "Registros: " + _toDisplayString(_unref(controle).composicoes.length), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("span", _hoisted_58, _toDisplayString(_unref(controle).statusComposicao), 1),
                        _createElementVNode("span", _hoisted_59, _toDisplayString(_unref(controle).erroComposicao), 1)
                      ])
                    ], 64))
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _cache[43] || (_cache[43] = _createElementVNode("label", { class: "mb-2" }, "Variáveis disponíveis: [ASSINATURACONTRATADA] [CLIENTENOME] [CLIENTENASCIMENTO] [CLIENTECPF] [CONJUGENOME] [CONJUGECPF] [ASSINATURA] [DIA] [MES] [ANO]", -1)),
                    _cache[44] || (_cache[44] = _createElementVNode("label", {
                      for: "texto",
                      class: "form-label"
                    }, "Texto do Contrato", -1)),
                    _createVNode(_unref(Editor), {
                      "api-key": "lf6zyai00yc0p00geaaq5q6b0v4l7z09sbzn2xsankgk4zi7",
                      init: {
                        height: 700,
                        menubar: true,
                        plugins: [
                          'advlist autolink lists link image charmap print preview anchor',
                          'searchreplace visualblocks code fullscreen',
                          'insertdatetime media table paste code help wordcount'
                        ],
                        toolbar:
                          'undo redo | formatselect | bold italic backcolor | \
                          alignleft aligncenter alignright alignjustify | \
                          bullist numlist outdent indent | removeformat | help'
                      },
                      modelValue: _unref(controle).model.texto,
                      "onUpdate:modelValue": [
                        _cache[19] || (_cache[19] = ($event: any) => ((_unref(controle).model.texto) = $event)),
                        _cache[20] || (_cache[20] = (value) => _unref(controle).model.texto = value)
                      ]
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("a", {
                  class: "btn btn-sm btn-primary",
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (salvar()))
                }, "Gravar")
              ]),
              _createElementVNode("div", _hoisted_66, [
                (_unref(controle).erro == null && _unref(controle).status != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(_unref(controle).status), 1))
                  : _createCommentVNode("", true),
                (_unref(controle).erro != null )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, _toDisplayString(_unref(controle).erro), 1))
                  : _createCommentVNode("", true)
              ]),
              _cache[47] || (_cache[47] = _createElementVNode("div", { class: "col-md-4" }, null, -1)),
              _createElementVNode("div", _hoisted_69, [
                _createVNode(_component_RouterLink, {
                  class: "btn btn-sm btn-secondary float-end",
                  to: '/contratos'
                }, {
                  default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                    _createTextVNode("Fechar", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})